import './styles.scss'
import I18n from 'lib/i18n'

import React from 'react'
import { useActions, useValues } from 'kea'

import FloatIfAbove from 'lib/tags/float-if-above'

import filtersLogic from '~/scenes/search/filters-page/logic'

import searchLogic from '~/scenes/search/logic'
import PropTypes from 'prop-types'

function BottomAction ({ locationBottomActionsStyles, handleSearch }) {
  return (
    <div
      className={`bottom-actions-container ${locationBottomActionsStyles && 'location-bottom-actions-container'}`}
      style={{ textAlign: 'center' }}
    >
      <button type='button' onClick={handleSearch}>
        {I18n.t('main.search.search')}
      </button>
    </div>
  )
}

function BottomActions ({ locationBottomActionsStyles }) {
  const { applyFilter, clearSuggestionResults, clearChanges } = useActions(filtersLogic)
  const { activeSubMenu, shouldIgnoreCategoryTagsFilter } = useValues(filtersLogic)
  const { receiveResults, setOpenFilters } = useActions(searchLogic)
  const { results, filter } = useValues(searchLogic)

  const handleSearch = () => {
    if (activeSubMenu === 'category_tags' && shouldIgnoreCategoryTagsFilter) {
      clearChanges()
      setOpenFilters('')
      return
    }

    const {
      helmet,
      helmet: { meta }
    } = results
    receiveResults(
      { ...results, helmet: { ...helmet, meta: meta.filter(metaTag => metaTag.name !== 'viewport') } },
      filter
    )
    applyFilter('')
    clearSuggestionResults()
  }

  if (locationBottomActionsStyles) {
    return (
      <div className='bottom-all-filters-actions'>
        <BottomAction locationBottomActionsStyles handleSearch={handleSearch} />
      </div>
    )
  } else {
    return (
      <FloatIfAbove className='bottom-all-filters-actions'>
        <BottomAction handleSearch={handleSearch} />
      </FloatIfAbove>
    )
  }
}

BottomAction.propTypes = {
  locationBottomActionsStyles: PropTypes.bool,
  handleSearch: PropTypes.func
}

BottomActions.propTypes = {
  locationBottomActionsStyles: PropTypes.bool
}

export default BottomActions
